<template>
  <Teleport to="body">
    <!-- Modal -->
    <Transition name="modal">
      <div v-if="props.showSubscribe" class="modal-mask-subs">
        <div class="modal-container">
          <div class="modal-body">
            <div class="row d-flex justify-content-center align-items-center">
              <div class="col header-text-1 d-flex justify-content-center mt-1">
                {{ translate.footer1ModalPlan }}
              </div>
              <div>
                <button
                  type="button"
                  @click="emit('showModalSubscribePlans', false)"
                  aria-label="Close"
                  style="z-index: 10; position: absolute; font-size: 40px; top: -57px; right: 18px"
                >
                  x
                </button>
              </div>
            </div>
            <form @submit.prevent="getLogin">
              <div class="form-group row d-flex align-items-center px-lg-5 px-2">
                <div class="col-lg-5 col-12">
                  <input
                    type="text"
                    class="form-control"
                    id="inputEmail"
                    aria-describedby="emailHelp"
                    :placeholder="translate2.placeHolderEmail"
                    name="email"
                    v-model="email"
                  />
                </div>
                <div class="col-lg-5 col-12 input-group">
                  <input
                    v-if="hidden"
                    type="password"
                    class="form-control"
                    name="password"
                    id="inputPassword"
                    :placeholder="translate2.placeHolderPassword"
                    autocomplete="current-password"
                    v-model="password"
                  />
                  <input
                    v-if="!hidden"
                    type="text"
                    class="form-control"
                    name="password"
                    id="inputPassword2"
                    :placeholder="translate2.placeHolderPassword"
                    autocomplete="current-password"
                    v-model="password"
                  />
                  <i @click="hiddenPassword" class="input-group-text icon-eye"></i>
                </div>
                <div class="col-lg-2 col-12 text-center" v-if="loading">
                  <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
                <div class="col-lg-2 col-12 d-flex justify-content-center" v-else>
                  <div class="d-w-btn">
                    <button>{{ translate2.buttonLabel }} <i class="icon-arrow-right"></i></button>
                  </div>
                </div>
              </div>
              <div>
                <div class="col-12 d-flex justify-content-center pb-3">
                  <span class="small">{{ translate2.forgotPwd1 }}</span
                  >&nbsp;
                  <span class="small small-link" @click="showModalForgotPassword(true)">{{
                    translate2.forgotPwd2
                  }}</span>
                </div>
              </div>
            </form>
            <div class="row d-flex justify-content-center">
              <div class="col-8">
                <LoginSocialMedia :redirect="false" size="240" @returnMessage="returnMessage" />
              </div>
            </div>
            <hr v-if="!isMobile()" />
            <div class="l-main">
              <div class="row img-mobile">
                <div
                  class="col-xl-3 col-lg-3 col-md-3 col-12 order-1 order-lg-1"
                  v-if="!isMobile()"
                >
                  <img :src="BgAssine" alt="Background Pre Assine" width="342" />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-12 order-2 order-lg-2">
                  <BoxTitleAssinante />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-12 order-3 order-lg-3">
                  <BoxTitleCardCredits />
                </div>
              </div>
              <div
                :class="
                  isMobile() ? 'd-flex justify-content-center' : 'd-flex justify-content-start'
                "
              >
                <img class="mx-3 mb-5" :src="IconeBds" alt="Logo Horizontal Bella" width="354" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
  <ModalForgotPassword
    :showModalPwd="showModalPwd"
    @showModalForgotPassword="showModalForgotPassword"
    @showModalMessages="showModalMessages"
  />
  <ModalMessages :options="optionsModal" @showModalMessages="showModalMessages" />
</template>

<script setup lang="ts">
 import { computed, onBeforeMount, ref } from 'vue'
  import BgAssine from 'assets/img/bg-pre-assine.webp'
  import ModalMessages from '../../components/Modais/ModalMessages.vue'
  import ModalForgotPassword from '../../components/Modais/ModalForgotPassword.vue'
  import LoginSocialMedia from '../LoginSocialMedia.vue'
  import router from '../../router'
  import translaters from '../../tradutors/myaccount'
  import { localeStore } from '../../stores/locale'
  import { planCreditStore } from '../../stores/planscredits'
  import { userStore } from '../../stores/user'
  import { jwtStore } from '../../stores/jwt'
  import IconeBds from 'assets/img/logo_BDS_horizontal.png'
  import { isMobile } from '../../views/shared/utils/mobile'
  import api from '../../api'
  import { event } from 'vue-gtag'
  import BoxTitleCardCredits from '../Assine/BoxTitleCardCredits.vue'
  import BoxTitleAssinante from '../../components/Assine/BoxTitleCardPlans.vue'

  const storeLocale = localeStore()
  const storePlanCredit = planCreditStore()
  const storeUser = userStore()
  const storeJwt = jwtStore()

  const translate2 = computed(() =>
    storeLocale.locale === 'pt-br' ? translaters.portugues : translaters.ingles
  )

  const props = defineProps({
    showSubscribe: {
      type: Boolean,
      default: false
    },
    plans: {
      type: Array,
    },
    translate: {
      type: Object,
    }
  })

  const emit = defineEmits(['showModalSubscribePlans'])

  const hidden = ref(true)
  const password = ref('')
  const email = ref('')
  const loading = ref(false)
  const optionsModal = ref({
    showModal: false,
    titleModal: 'Erro',
    textBodyModal: '',
    textButtonModal: ''
  })
  const showModalPwd = ref(false)

  onBeforeMount(() => {
    if (
      storeLocale.locale !== storePlanCredit.languagePlansCredits ||
      !storePlanCredit.plansCredits ||
      router.currentRoute.value.query.voucher ||
      router.currentRoute.value.query.coupon
    )
      getPlansCredits()
  })

  function hiddenPassword() {
    hidden.value = !hidden.value
  }
  function getPlansCredits() {
    api
      .get(
        `v1/home/getPlansCredits?language=${storeLocale.locale ?? ''}&coupon=${
          router.currentRoute.value.query.coupon ?? ''
        }`
      )
      .then(({ data }) => {
        storePlanCredit.setPlanCredits(data.plans)
      })
  }
  interface IForm {
    email: string
    password: string
  }
  function checkForm(form: IForm) {
    if (!form.email) {
      error(storeLocale.locale == 'pt-br' ? 'Email é obrigatório!' : 'Email is required!')
      return false
    }
    if (!form.password) {
      error(storeLocale.locale == 'pt-br' ? 'Senha é obrigatória!' : 'Password is required!')
      return false
    }
    return true
  }
  function error(value: string) {
    showModalMessages({
      message: { show: true, title: 'Erro', textButton: 'Fechar', textBoby: value }
    })
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'erro',
      erro: {
        tipo: value
      }
    })
  }
  function showModalMessages({ message }) {
    optionsModal.value.showModal = message.show
    optionsModal.value.titleModal = message.title
    optionsModal.value.textBodyModal = message.textBoby
    optionsModal.value.textButtonModal = message.textButton
  }
  async function getLogin() {
    loading.value = true
    let body = {
      email: email.value,
      password: password.value
    }
    if (checkForm(body))
      await api
        .post('auth/login', body, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }
        })
        .then(async ({ data }) => {
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'login',
            login: { email: email.value }
          })
          event('login2', { login: { email: email.value } })
          await storeUser.setUser(data.user)
          await storeJwt.setJwt(data.authorisation.token)
          await storeUser.getActiveUser()
          window.location.reload()
        })
        .catch(({ response: { data } }) => {
          if (data.errors) {
            let array = Array.from(Object.entries(data.errors), ([key, value]) => value)
            error(array[0][0])
          } else
            error(
              storeLocale.locale == 'pt-br'
                ? 'Email ou Senha inválidos'
                : 'Email or Password invalid'
            )
        })
        .finally(() => {
          loading.value = false
        })
    else loading.value = false
  }
  function showModalForgotPassword(data) {
    showModalPwd.value = data
  }
  function returnMessage(value: string) {
    error(value)
  }
</script>

<style scoped lang="css">
  .img-middle {
    width: 100%;
    height: 600px;
    right: -1px;
  }
  .title {
    color: #ffffff;
    font-family: 'Bebas-Neue-Light';
    font-size: 72px;
    font-weight: 300;
    letter-spacing: 0;
    text-align: center;
    text-transform: uppercase;
  }

  .subtitle {
    color: #ffffff;
    font-family: 'Exo-2';
    font-size: 24px;
    letter-spacing: 0;
    text-align: center;
  }

  .footer-credits {
    display: flex;
    flex-direction: row;
    color: #000;
    font-family: 'Roboto-Regular';
    font-size: 12px;
    font-weight: 700;
    font-style: italic;
    letter-spacing: 0;
    line-height: 15px;
  }

  .textBody {
    height: 28px;
    color: #b20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
  }

  .text-header-1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .footer2 {
    color: #b20000;
    font-weight: 600;
  }

  .modal-mask-subs {
    position: fixed;
    z-index: 9997;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    transition: opacity 0.3s ease;
    overflow-y: auto;
  }

  .modal-container {
    width: 1000px;
    margin: auto;
    padding: 0px;
    background-color: #fff;
    border-radius: 0px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
  }

  .modal-header {
    align-items: center;
    justify-content: end;
  }

  .modal-body {
    margin: 0;
  }
  .modal-default-button {
    float: right;
  }

  .credits li p {
    color: #333;
    font-family: 'Exo-2';
    font-size: 13px;
    letter-spacing: 0;
    font-weight: 400;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

  .modal-enter-from {
    opacity: 0;
  }

  .modal-leave-to {
    opacity: 0;
  }

  .modal-enter-from .modal-container,
  .modal-leave-to .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .img-header {
    width: 100%;
  }

  .div-footer {
    width: 30%;
  }

  .div-plans {
    padding: 0px !important;
    margin-inline-start: -40px;
    margin-top: -80px;
  }

  .header-text-1 {
    font-family: 'Bebas-Neue';
    font-size: 32px;
    font-weight: 300;
    letter-spacing: 0;
    text-transform: uppercase;
  }

  .header-text-2 {
    font-family: 'Bebas-Neue-Light';
    font-size: 25px;
    font-weight: 300;
    letter-spacing: 0;
    text-transform: uppercase;
    color: black;
  }

  .d-w-btn button {
    color: #fff;
    padding: 5px;
  }

  .d-w-btn {
    width: 130px;
    background: #000;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 11px;
    color: #ffffff;
    font-family: 'Exo-2';
    font-size: 16px;
    letter-spacing: 0;
    top: -7px;
  }

  .form-group input {
    padding: 15px 20px;
    border-radius: 30px;
    margin-bottom: 15px;
    background-color: #f8f8f8;
    font-size: small;
  }

  .input-group {
    width: 41.66666667%;
  }
  .input-group-text {
    padding: 0;
    padding-left: 5px;
    font-size: 2rem;
    background-color: #f8f8f8;
    border: 1px solid #ced4da;
    border-radius: 30px;
    border-left-style: hidden;
    height: 52px;
  }

  #inputPassword2 {
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
  }

  .icon-eye:before {
    color: #ced4da;
    margin-right: 0.5em;
    cursor: pointer;
  }

  .small {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 13px;
    letter-spacing: 0;
    line-height: 15px;
  }

  .small-link {
    color: #b20000;
    font-family: 'Roboto-Medium';
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 15px;
    text-decoration: underline;
    cursor: pointer;
  }

  hr {
    margin-top: unset;
    margin-bottom: unset;
  }

  .bulleted-list img {
    width: 10px;
    height: 10px;
    margin-right: 10px;
    object-fit: cover;
  }

  .bulleted-list li {
    display: flex;
    margin-bottom: 0px;
    font-family: 'Exo-2';
    font-size: 13px;
  }

  .div-header-text h2 {
    color: #ff6000;
    font-family: 'Roboto-Bold';
    font-size: 28px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24px;
  }

  .div-header-text h3 {
    color: #000000;
    font-family: 'Roboto-Bold';
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 18px;
  }

  .div-header-text2 {
    font-size: 12px;
    margin-bottom: 10px;
    font-family: 'Roboto-Regular';
  }

  .div-header-text-credits h2 {
    color: #ff6000;
    font-family: 'Roboto-Bold';
    font-size: 28px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24px;
    width: 100%;
  }

  .div-header-text-credits h3 {
    color: #000000;
    font-family: 'Roboto-Bold';
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 18px;
    width: 100%;
  }

  .list-items {
    font-family: 'Roboto-Regular';
    margin-bottom: 0px;
    top: -4px;
  }

  .footer {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 12px;
    font-style: italic;
    letter-spacing: 0;
    line-height: 15px;
  }

  .spinner-border {
    top: -5px;
  }

  .py-1-footer {
    padding-bottom: 8px;
    padding-top: 10px;
  }
  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .modal-container {
      width: 95%;
    }

    .title {
      font-size: 45px;
      margin-top: 30px;
    }

    .subtitle {
      font-size: 16px;
    }
    .img-header {
      width: 100%;
      height: unset;
    }

    .textBody {
      display: none;
    }

    .div-plans {
      padding: 0px !important;
      width: 100%;
      margin: 0 auto;
      margin-top: -3rem;
    }
    .div-footer {
      width: 90%;
    }

    .input-group {
      width: 100%;
    }

    h2,
    h3 {
      margin-bottom: 0px;
    }

    .div-header-text h2 {
      font-size: 20px;
      line-height: unset;
    }
    .div-header-text h3 {
      font-size: 17px;
      line-height: unset;
    }

    .form-group input {
      padding: 8px 20px;
    }

    .input-group-text {
      height: 37px;
    }
    .d-w-btn {
      padding: 5px;
    }

    .bulleted-list {
      padding-top: 8px;
    }
    .back-gray {
      background-color: #f2f2f2;
    }

    .div-header-text h2 {
      margin-top: -10px;
    }

    .div-header-text-credits {
      padding-top: 3rem;
      padding-inline: 1rem;
    }
    .credits {
      padding-inline: 1rem;
    }

    .div-header-text-credits h2 {
      font-size: 20px;
      line-height: 24px;
      text-align: center;
    }

    .div-header-text-credits h3 {
      font-size: 17px;
      line-height: 28px;
      text-align: center;
    }

    .footer-credits {
      font-size: 13px;
      line-height: 18px;
    }
    .footer {
      padding-left: 15px;
    }
  }
</style>
